import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DomainMobileGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(): boolean {
    const host = window.location.hostname;

    if (host.startsWith('m.')) {
      this.router.navigate(['/mobile/menu']);
      return false;
    } else {
      return true;
    }
  }
}
